<div class="theme_bg">
<div class="container hotel_review_booking nopad mt-4">
    <!-- <h3>Review Your Booking</h3> -->
    <div class="clearfix"></div>
    <div class="row mobile_row">
        <div class="col-md-8 col-lg-8">
            <form [formGroup]="travellerForm">
                <div class="col-md-12 col-lg-12 nopad">
                    <ng-container formArrayName="address">
                        <ng-container *ngFor="let item of travellerForm.get('address')['controls']; index as i "
                            [formGroupName]="i">
                            <div class="card mt-3" style="box-shadow: 0px 1px 16px #ddd;"  *ngIf="!currentUser">
                                <div class="card-body">
                                    <h5 class="card-title">Log in or register to enjoy this member-only benifit</h5>
                                    <a class="card-link" style="color: #189AD3;" data-toggle="modal" data-target="#show_log"
                                       >Log In or Register</a>
                                </div>
                            </div>
                            <div class="wrappay leftboks">
                                <h3>Contact Details</h3>
                                <div class="comon_backbg">
                                    <h5 class="inpagehed p-2">Contact Details (For E-Ticket/Voucher)</h5>
                                    <div class="sectionbuk">
                                        <div id="tdetails">
                                            <div class="onedept">
                                                <div class="row">
                                                    <div class="col-md-5 ">
                                                        <div class="paylabel">Email Address <b class="text-danger">*</b>
                                                        </div>
                                                        <input type="email" id="email" name="email" class="payinput"
                                                            aria-required="true" formControlName="Email" required />
                                                    </div>
                                                    <div class="col-md-4 ">
                                                        <div class="paylabel">Phone Code <b class="text-danger">*</b>
                                                        </div>
                                                        <div class="selectedwrap">
                                                            <select #selectedCountry
                                                                class="newslterinput nputbrd _numeric_only flpayinput"
                                                                id="before_country_code" formControlName="PhoneCode">
                                                                <option [selected]="p.id==281"
                                                                    *ngFor="let p of phoneCodes">
                                                                    {{p.name}} ({{ p.phone_code }})
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="paylabel">Contact <b class="text-danger">*</b>
                                                        </div>
                                                        <input type="text" id="mobile" name="mobile" class="payinput"
                                                            data-mask="000000000000" value="7406689854"
                                                            aria-required="true" formControlName="Contact" required />
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-5 ">
                                                        <small class="error text-danger" *ngIf="hasError('Email', 'required', 'address', i);">
                                                            Please Enter Email Address* <br>
                                                        </small>
                                                    </div>
                                                    <div class="col-md-4 ">
                                                    </div>
                                                    <div class="col-md-3">
                                                        <small class="error text-danger" *ngIf="hasError('Contact', 'required', 'address', i);">
                                                            Please Enter Contact No.* <br>
                                                        </small>
                                                    </div>
                                                </div>
                                                <div class="clearfix"></div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <div class="wrappay leftboks">
                        <h3>Your Information</h3>
                        <div class="comon_backbg">
                            <h5 class="inpagehed p-2">Guest Information</h5>
                            <div class="sectionbuk">
                                <div id="tdetails">
                                    <div class="onedept">
                                        <div class="pasenger_location m-0">
                                            <span class="hwonum" *ngIf="noOfAdults"> Adult {{noOfAdults +' ('+
                                                travellerForm.value['adults'].length +')'}} </span>
                                            <span class="hwonum" *ngIf="noOfChilds"> Child {{noOfChilds +' ('+
                                                travellerForm.value['childs'].length +')'}} </span>
                                        </div>
                                        <div class="payrow"
                                            style="overflow: inherit; position: absolute; z-index: 999; right: 0px; top:4px;display: none;">
                                            <div class="addreat cusromBlue" (click)="addAdultTravellers()">
                                                Add Adult <i class="fal fa-plus"></i>
                                            </div>
                                        </div>
                                        <div class="guest_div">
                                            <ng-container formArrayName="adults">
                                                <ng-container
                                                    *ngFor="let item of travellerForm.get('adults')['controls']; index as i"
                                                    [formGroupName]="i">
                                                    <div *ngIf="respData && respData.length>0">
                                                        <label class="textWeight whoare" style="line-height: 36px;">Select Adult ({{i+1}}) </label>
                                                        <mat-form-field class="col-md-3 f-16 ml-1" appearance="fill">
                                                            <mat-select formControlName="PassengerSelectionAdult" id="matselectAdult{{i}}">
                                                                <mat-option value="" disabled>Select Adult</mat-option>
                                                                <mat-option *ngFor="let option of respData" [value]="option.first_name"
                                                                    (click)="setAdultDetails(option,i, 'adults')">
                                                                    {{option.first_name}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                        <a class="passengerClear" (click)="clearAdultDetails(i,'matselectAdult'+i)"> Clear</a>
                                                    </div>
                                                    <div class="row parl">
                                                        <div class="col-md-2 downsrt pr-0">
                                                            <div class="lokter">
                                                                <span class="whoare">Adult
                                                                    ({{i+1}})</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 p-0 mpad">
                                                            <div class="paylabel">Title <b class="text-danger">*</b>
                                                            </div>
                                                            <div class="selectedwrap">
                                                                <select class="flpayinput text-uppercase" name="a_gender290[0]"
                                                                    id="a_gender_0" aria-required="true"
                                                                    formControlName="Title" required>
                                                                    <option value="" disabled>-Select-</option>
                                                                    <ng-container *ngFor="let t of titleList">
                                                                        <option *ngIf="t.paxType == 'ADULT'" value="{{t.titleName}}">
                                                                            {{t.titleName}}</option>
                                                                    </ng-container>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 pr-0">
                                                            <div class="paylabel">First Name <b
                                                                    class="text-danger">*</b> </div>
                                                            <input placeholder="First Name" name="first_name290[0]"
                                                                type="text" class="payinput mytextbox" value=""
                                                                id="flight-adult-first-0" aria-required="true"
                                                                formControlName="FirstName" required />

                                                        </div>
                                                        <div class="col-md-2 pr-0">
                                                            <div class="paylabel">Last Name</div>
                                                            <input placeholder="Last Name" name="last_name290[0]"
                                                                type="text" class="payinput mytextbox"
                                                                id="flight-adult-last-0" value="" aria-required="true"
                                                                formControlName="LastName" />
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="paylabel">Date of Birth <b
                                                                    class="text-danger">*</b>
                                                            </div>
                                                            <input name="adult_dob290[0]" id="adult_dob2900" type="text"
                                                                class="flpayinput date_picker_adult hasDatepicker"
                                                                value="" placeholder="dd-mm-yyyy" readonly=""
                                                                data-id="0" aria-required="true" formControlName="Dob"
                                                                bsDatepicker [bsConfig]="bsConfig"
                                                                [maxDate]="maxDateAdult" required />
                                                        </div>
                                                        <div class="col-md-1"  style="display: none;">
                                                            <div class="clearfix"></div>
                                                            <div class="float-right">
                                                                <div class="valign-wrapper">
                                                                    <div class="btnminus"
                                                                        (click)="removeAdultTravellers(i)">
                                                                        <span><i class="fal fa-times"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="row">
                                                                <div class="offset-md-6 col-md-6 nopad">
                                                                    <small class="error text-danger"
                                                                        *ngIf="hasError('Title', 'required', 'adults', i);">
                                                                        Please Select Title*
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-8">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <small class="error text-danger" *ngIf="hasError('FirstName', 'required', 'adults', i);">
                                                                        Please Enter First Name* <br>
                                                                    </small>
                                                                    <small class="error text-danger"
                                                                    *ngIf="hasError('FirstName', 'maxlength', 'adults', i);">
                                                                        Maximum Characters Exceeded* <br>
                                                                    </small>
                                                                    <small class="error text-danger" 
                                                                    *ngIf="hasError('FirstName', 'minlength', 'adults', i);">
                                                                        At Least 1 Character Required* <br>
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('FirstName', 'pattern', 'adults', i);">
                                                                        Please Enter a Valid Name* <br>
                                                                    </small>
                                                        
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <small class="error text-danger" *ngIf="hasError('LastName', 'maxlength', 'adults', i);">
                                                                        Maximum Characters Exceeded* <br>
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('LastName', 'minlength', 'adults', i);">
                                                                        At Least 2 Characters Required* <br>
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('LastName', 'pattern', 'adults', i);">
                                                                        Please Enter a Valid Name* <br>
                                                                    </small>
                                                                </div>
                                                                <div class="col-md-4 nopad">
                                                                    <small class="error text-danger" *ngIf="hasError('Dob', 'required', 'adults', i);">
                                                                        Please Select DOB*
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('Dob', 'bsDate', 'adults', i);">
                                                                        Please Enter Valid DOB*
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                        </div>

                                        <div class="clearfix"></div>
                                        <div class="payrow pb-2" *ngIf="noOfChilds">
                                            <div class="addreat cusromBlue" (click)="addChildTravellers()" style="position: absolute;
                                        right: 0px;
                                        top: 4px; display: none;">
                                                Add Child <i class="fal fa-plus"></i>
                                            </div>
                                        </div>

                                        <div class="guest_div" style="border-bottom: none;">
                                            <ng-container formArrayName="childs">
                                                <ng-container
                                                    *ngFor="let item of travellerForm.get('childs')['controls']; index as i"
                                                    [formGroupName]="i">
                                                    <div *ngIf="respData && respData.length>0">
                                                        <label class="textWeight whoare" style="line-height: 36px;">Select Child ({{i+1}})</label>
                                                        <mat-form-field class="col-md-3 f-16 ml-1" appearance="fill">
                                                            <mat-select formControlName="PassengerSelectionChild" id="matselectChild{{i}}">
                                                                <mat-option value="" disabled>Select Child</mat-option>
                                                                <mat-option *ngFor="let option of respData" [value]="option.first_name"
                                                                    (click)="setChildDetails(option,i,'childrens')">
                                                                    {{option.first_name}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                        <a class="passengerClear" (click)="clearChildDetails(i,'matselectChild'+i)"> Clear</a>
                                                    </div>
                                                    <div class="row parl">
                                                        <div class="col-md-2 downsrt pr-0">
                                                            <div class="lokter">
                                                                <span class="whoare">
                                                                    Child ({{i+1}})
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 p-0">
                                                            <div class="paylabel">Title <b class="text-danger">*</b>
                                                            </div>
                                                            <div class="selectedwrap">
                                                                <select class="flpayinput text-uppercase" name="a_gender290[0]"
                                                                    id="a_gender_0" aria-required="true"
                                                                    formControlName="Title" required>
                                                                    <option value="" disabled>-Select-</option>
                                                                    <ng-container *ngFor="let t of titleList">
                                                                        <option *ngIf="t.paxType == 'CHILD'" value="{{t.titleName}}">
                                                                            {{t.titleName}}</option>
                                                                    </ng-container>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 pr-0">
                                                            <div class="paylabel">First Name <b
                                                                    class="text-danger">*</b></div>
                                                            <input placeholder="First Name" name="first_name290[0]"
                                                                type="text" class="payinput mytextbox" value=""
                                                                id="flight-adult-first-0" aria-required="true"
                                                                formControlName="FirstName" required />
                                                        </div>
                                                        <div class="col-md-2 pr-0">
                                                            <div class="paylabel">Last Name</div>
                                                            <input placeholder="Last Name" name="last_name290[0]"
                                                                type="text" class="payinput mytextbox"
                                                                id="flight-adult-last-0" value="" aria-required="true"
                                                                formControlName="LastName" />
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="paylabel">Date of Birth <b
                                                                    class="text-danger">*</b>
                                                            </div>
                                                            <input name="adult_dob290[0]" id="adult_dob2900" type="text"
                                                                class="flpayinput date_picker_adult hasDatepicker"
                                                                value="" placeholder="dd-mm-yyyy" readonly=""
                                                                data-id="0" aria-required="true" formControlName="Dob"
                                                                bsDatepicker [bsConfig]="bsConfig"
                                                                [maxDate]="maxChildDate" required />
                                                        </div>
                                                        <div class="col-md-1" style="display: none;">
                                                            <div class="clearfix"></div>
                                                            <div class="float-right" >
                                                                <div class="valign-wrapper">
                                                                    <div class="btnminus"
                                                                        (click)="removeChildTravellers(i)">
                                                                        <span><i class="fal fa-times"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="row">
                                                                <div class="offset-md-6 col-md-6 nopad">
                                                                    <small class="error text-danger"
                                                                        *ngIf="hasError('Title', 'required', 'childs', i);">
                                                                        Please Select Title*
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="col-md-8">
                                                            <div class="row">
                                                                <div class="col-md-4 ">
                                                                    <small class="error text-danger" *ngIf="hasError('FirstName', 'required', 'childs', i);">
                                                                        Please Enter First Name* <br>
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('FirstName', 'maxlength', 'childs', i);">
                                                                        Maximum Characters Exceeded* <br>
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('FirstName', 'minlength', 'childs', i);">
                                                                        At Least 1 Character Required* <br>
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('FirstName', 'pattern', 'childs', i);">
                                                                        Please Enter a Valid Name* <br>
                                                                    </small>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <small class="error text-danger" *ngIf="hasError('LastName', 'maxlength', 'childs', i);">
                                                                        Maximum Characters Exceeded* <br>
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('LastName', 'minlength', 'childs', i);">
                                                                        At Least 1 Character Required* <br>
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('LastName', 'pattern', 'childs', i);">
                                                                        Please Enter a Valid Name* <br>
                                                                    </small>
                                                                </div>
                                                                <div class="col-md-4 nopad">
                                                                    <small class="error text-danger" *ngIf="hasError('Dob', 'required', 'childs', i);">
                                                                        Please Select DOB*
                                                                    </small>
                                                                    <small class="error text-danger" *ngIf="hasError('Dob', 'bsDate', 'childs', i);">
                                                                        Please Select Valid DOB*
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-container formArrayName="address">
                        <ng-container *ngFor="let item of travellerForm.get('address')['controls']; index as i "
                            [formGroupName]="i">
                            <div class="comon_backbg">
                                <h5 class="inpagehed p-2">Address</h5>
                                <div class="sectionbuk billingnob">
                                    <div class="payrow">
                                        <div class="valign-wrapper row">
                                            <div class="col-md-2 ">
                                                <div class="paylabel">Salutation <b class="text-danger">*</b> </div>
                                                <div class="selectedwrap">
                                                    <select class="flpayinput capitalize" name="saluation" formControlName="Title"
                                                        required>
                                                        <option value="" disabled>-Select-</option>
                                                        <ng-container *ngFor="let t of titleList">
                                                            <option *ngIf="t.paxType == 'ADULT'" value="{{t.titleName}}">
                                                                {{t.titleName}}</option>
                                                        </ng-container>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-5 ">
                                                <div class="paylabel">First Name <b class="text-danger">*</b> </div>
                                                <input type="text" id="first_name" name="first_name" class="payinput mytextbox capitalize"
                                                    value="test" formControlName="FirstName" required />
                                            </div>
                                            <div class="col-md-5 ">
                                                <div class="paylabel">Last Name <b class="text-danger">*</b> </div>
                                                <input type="text" id="last_name" name="last_name" class="payinput mytextbox capitalize"
                                                    value="test" formControlName="LastName" required />
                                            </div>
                                        </div>
                                        <div class="valign-wrapper row">
                                            <div class="col-md-2">
                                                <small class="error text-danger"
                                                    *ngIf="hasError('Title', 'required', 'address', i);">
                                                    Please Select Salutation*
                                                </small>
                                            </div>
                                            <div class="col-md-5">
                                                <small class="error text-danger"
                                                    *ngIf="hasError('FirstName', 'required', 'address', i);">
                                                    Please Enter First Name* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('FirstName', 'maxlength', 'address', i);">
                                                    Maximum Characters Exceeded* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('FirstName', 'minlength', 'address', i);">
                                                    At Least 1 Character Required* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('FirstName', 'pattern', 'address', i);">
                                                    Please Enter a Valid First Name* <br>
                                                </small>
                                            </div>
                                            <div class="col-md-5">
                                                <small class="error text-danger"
                                                    *ngIf="hasError('LastName', 'required', 'address', i);">
                                                    Please Enter Last Name* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('LastName', 'pattern', 'address', i);">
                                                    Please Enter a Valid Last Name* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('LastName', 'maxlength', 'address', i);">
                                                    Maximum Characters Exceeded* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('LastName', 'minlength', 'address', i);">
                                                    At Least 1 Character Required* <br>
                                                </small>
                                            </div>
                                        </div>
                                        <div class="valign-wrapper row">
                                            <div class="col-md-4 ">
                                                <div class="paylabel">Address <b class="text-danger">*</b> </div>
                                                <input type="text" id="street_address" name="street_address"
                                                    class="payinput" value="bangalore" aria-required="true"
                                                    formControlName="Address" required />
                                            </div>
                                            <div class="col-md-4 ">
                                                <div class="paylabel">Address2</div>
                                                <input type="text" id="address2" name="address2" class="payinput"
                                                    value="bangalore" formControlName="Address2" />
                                            </div>
                                            <div class="col-md-4 ">
                                                <div class="paylabel">City <b class="text-danger">*</b> </div>
                                                <input type="text" id="city" name="city" class="payinput mytextbox"
                                                    value="bangalore" aria-required="true" formControlName="City"
                                                    required />
                                            </div>
                                        </div>

                                        <div class="valign-wrapper row">
                                            <div class="col-md-4">
                                                <small class="error text-danger"
                                                    *ngIf="hasError('Address', 'required', 'address', i);">
                                                    Please Enter Address* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('Address', 'maxlength', 'address', i);">
                                                    Maximum Characters Exceeded* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('Address', 'minlength', 'address', i);">
                                                    At Leasr 2 Characters Required* <br>
                                                </small>
                                            </div>
                                            <div class="col-md-4">
                                                <small class="error text-danger"
                                                    *ngIf="hasError('Address2', 'maxlength', 'address', i);">
                                                    Maximum Characters Exceeded* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('Address2', 'minlength', 'address', i);">
                                                    At Least 2 Characters Required* <br>
                                                </small>
                                            </div>
                                            <div class="col-md-4">
                                                <small class="error text-danger"
                                                    *ngIf="hasError('City', 'required', 'address', i);">
                                                    Please Enter City* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('City', 'maxlength', 'address', i);">
                                                    Maximum Characters Exceeded* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('City', 'minlength', 'address', i);">
                                                    At Least 2 Characters Required* <br>
                                                </small>
                                            </div>
                                        </div>

                                        <div class="valign-wrapper row">
                                            <div class="col-md-4 ">
                                                <div class="paylabel">State <b class="text-danger">*</b> </div>
                                                <input type="text" id="state" name="state" class="payinput mytextbox"
                                                    value="karnataka" aria-required="true" formControlName="State"
                                                    required />
                                            </div>
                                            <div class="col-md-4 ">
                                                <div class="paylabel">Postal Code <b class="text-danger">*</b> </div>
                                                <input type="text" id="zip" data-mask="000000000" name="zip"
                                                    class="payinput" aria-required="true" formControlName="PostalCode"
                                                    required />
                                            </div>
                                            <div class="col-md-4 ">
                                                <div class="paylabel">Country <b class="text-danger">*</b> </div>
                                                <div class="selectedwrap">
                                                    <select class="flpayinput" id="country" name="country"
                                                        aria-required="true" formControlName="Country" required>
                                                        <option value="" disabled>-Select-</option>
                                                        <option *ngFor="let c of countries" value="{{c.code}}">
                                                            {{c.name}}</option>
                                                    </select>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="valign-wrapper row">
                                            <div class="col-md-4">
                                                <small class="error text-danger"
                                                    *ngIf="hasError('State', 'required', 'address', i);">
                                                    Please Enter State* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('State', 'maxlength', 'address', i);">
                                                    Maximum Characters Exceeded* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('State', 'minlength', 'address', i);">
                                                    At Least 2 Characters Required* <br>
                                                </small>
                                            </div>
                                            <div class="col-md-4">
                                                <small class="error text-danger"
                                                    *ngIf="hasError('PostalCode', 'required', 'address', i);">
                                                    Please Enter Postal Code* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('PostalCode', 'pattern', 'address', i);">
                                                    Please Enter a Valid Postal Code* <br>
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="hasError('PostalCode', 'maxlength', 'address', i);">
                                                    Maximum No.'s Of Digits Exceeded* <br>
                                                </small>
                                            </div>

                                            <div class="col-md-4 nopad">
                                                <small class="error text-danger"
                                                    *ngIf="hasError('Country', 'required', 'address', i);">
                                                    Please Select Country*
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="wrappay leftboks">
                    <div class="comon_backbg">
                        <h5 class="inpagehed p-2">Remarks</h5>
                        <div class="sectionbuk">
                            <div id="tdetails">
                                <div class="onedept">
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <p style="font: 14px;">Special requests cannot be guaranteed–but the
                                                property will do its best to meet your needs.
                                                You can always make a special request after your booking is complete!
                                            </p>
                                        </div>
                                        <div class="col-md-12 ">
                                            <textarea style="height:120px;" class="payinput"></textarea>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="col-md-12 nopad">
                    <div class="col-md-12 nopad">
                        <div class="checkcontent" style="overflow: inherit;">
                            <div class="customSquaredThree">
                                <input type="checkbox" value="0" name="confirm" class="filter_airline"
                                    id="squaredThree1" aria-required="true" formControlName="Aggreed" required />
                                <label for="squaredThree1"></label>
                            </div>
                            <label for="squaredThree1" class="lbllbl" style="display: inline; font-size: 14px;">
                                By booking this item , you agree to our
                                <a data-toggle="modal" (click)="openStaticPage('terms-conditions')" class="colorbl">Terms and Conditions</a>,
                                <a data-toggle="modal" (click)="openStaticPage('privacy-policy')" class="colorbl">Privacy Policy</a>
                                 and <a data-toggle="modal" (click)="openStaticPage('refund-policy')" class="colorbl">Refund Policy</a>.
                            </label>
                        </div>
                        <div class="checkcontent" style="overflow: inherit;">
                            <small class="text-danger"
                                *ngIf="submitted && travellerForm['controls']['Aggreed'].errors?.required">
                                Please Check The Agreement*
                            </small>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="payrowsubmt">
                        <div class="col-md-3 col-sm-12 fulat500 nopad">
                            <button type="submit" class="paysubmit" name="continue" id="continue" value="Continue"
                                (click)="onSubmit()">
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-md-4 col-lg-4 pl-0 mobile_pad mobile_top pl40"
            style="position: sticky;top: 20px; margin-top: 50px; align-self: start;">
            <div class="comon_backbg">
                <h5 class="inpagehed p-2" style="color: #000;">Booking Summary</h5>
                <div class="col-md-12">
                    <div class="row font-weight-bold pt-3 pb-3 hotl_details_name">
                        <div class="col-md-4">
                            <img class="imgStyle" src="{{hotel.HotelPicture}}" alt="">
                        </div>
                        <div class="col-md-8 pl-0 mobile_pad">
                            <h5 class="cusromGrey"><strong>{{hotel.HotelName}}</strong> </h5>
                            <ng-template *ngIf="hotel.StarRating === '' then noStar; else stars">
                            </ng-template>
                            <ng-template #noStar>
                                <span class="star_rtng">
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                </span>
                            </ng-template>
                            <ng-template #stars>
                                <span class="star_rtng">
                                    <i class="fas fa-star star_rtng_clr"
                                        *ngFor="let s of hotel.StarRating | map: getStarArray"></i>
                                    <i class="fas fa-star"
                                        *ngFor="let s of hotel.StarRating | map: getStarArrayRemaining"></i>
                                </span>
                            </ng-template>
                            <p class="cusromGrey">
                                {{hotel.HotelAddress}}
                            </p>
                        </div>
                    </div>

                    <div class="row font-weight-bold pt-3 pb-3 hotl_details_check">
                        <div class="col-md-4 px-3">
                            <p class="cusromgray m-0">
                                Check-In:
                            </p>
                            <p class="cusromBlue m-0">
                                {{hotel.CheckIn | date: 'dd MMM yyyy'}}
                            </p>
                        </div>
                        <div class="col-md-4 px-3">
                            <p class="cusromgray m-0">
                                Check-Out:
                            </p>
                            <p class="cusromBlue m-0">
                                {{hotel.CheckOut | date: 'dd MMM yyyy'}}
                            </p>
                        </div>

                        <div class="col-md-4 px-y">
                            <p class="cusromgray m-0">
                                No of Nights:
                            </p>
                            <p class="cusromBlue m-0">
                                {{nights}}
                            </p>
                        </div>
                    </div>

                    <div class="row pt-3 pb-3 trooms_desc">
                        <div class="col-md-12 px-3">
                            <h5 *ngFor="let room of hotel.RoomDetails
                            ">{{room.Description}}</h5>
                            <div class="clearfix"></div>

                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-4 nopad">
                                    <span class="cusromBlue m-0">
                                        Room Type:
                                    </span>
                                </div>

                                <div class="col-md-6 col-8 nopad text-right">
                                    <span class="m-0 pull-right" *ngFor="let room of hotel.RoomDetails.Rooms">
                                        {{room.Description}}
                                    </span>
                                </div>
                            </div>
                            <div class="clearfix"></div>

                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        Adult(s):
                                    </span>
                                </div>
                                <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right">
                                        {{noOfAdults}}
                                    </span>
                                </div>
                            </div>

                            <div class="clearfix"></div>

                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        No of Children:
                                    </span>
                                </div>

                                <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right">
                                        {{noOfChilds}}
                                    </span>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="row trooms_desc pt-3 pb-3">
                        <div class="col-md-12 px-3">
                            <h5>Your Price Summary</h5>
                            <div class="clearfix"></div>
                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        Price:
                                    </span>
                                </div>
                                <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right ">
                                        {{hotel.Price.Currency}} {{hotel.Price.Amount | number:'1.1-2'}}
                                    </span>
                                </div>

                            </div>
                            <div class="clearfix"></div>

                            <div class="valign-wrapper mt-1 mb-1">
                                <!-- <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        Convenience Fee:
                                    </span>
                                </div> -->

                                <!-- <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right ">
                                        {{hotel.Price.Currency}} {{hotel.Price.Commission | number:'1.1-2'}}
                                    </span>
                                </div> -->
                                <div class="col-md-6 col-6 nopad" *ngIf="promocode">
                                    <span class="cusromBlue m-0">
                                        Discount:
                                    </span>
                                </div>
                                <div class="col-md-6 col-6 nopad text-right" *ngIf="promocode">
                                    <div class="m-0 pull-right">
                                        {{hotel.Price.Currency}} {{discount_value | number:'1.0-0'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h4 class="totel_price text-right">
                        Total: {{hotel.Price.Currency}} {{(hotel.Price.Amount - discount_value) |
                            number:'1.1-2'}}
                    </h4>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="bor mar20 coup">
                <div class="prc-h1 prc-cup"> Have a coupon code </div>
                <div class="cpn" id="divCouponCodeApply" style="display: block;">
                    <div class="cpn-l">
                        <input id="txtCouponCode" [(ngModel)]="txtCouponCodeValue" type="text" value="" placeholder="Enter Coupon Code"
                            minlength="1" [disabled]="disableApplyPromo">
                    </div>
                    <div class="cpn-r">
                        <div *ngIf="!disableApplyPromo" class="apl" [class.disabled]="!txtCouponCodeValue" (click)="applyCoupon()" [attr.disabled]="!txtCouponCodeValue ? true : null">Apply</div>
                        <div *ngIf="disableApplyPromo" class="apl" (click)="removeSelectedPromo()">Remove</div>
                    </div>
                </div>
                <div *ngIf="isInvalidPromo" class="error-message" style="color: red; padding-left: 10px;">Invalid Promocode</div>
                <div class="cpn_dvd" style="display:block"></div>
                <div class="clearfix"></div>
                <div class="coupn_inr">
                    <div class="coupn_scrl">
                        <div class="coupn_col">
                            <label class="coupn_radio" *ngFor="let promocode of promocodeList; let index=index">
                                <div class="coupn_ttl">{{promocode.promo_code}}</div>
                                <div class="coupn_para" id="cpnTxtEMTNCF">{{promocode.description}}</div>
                                <input type="radio" (click)="setSelectedPromo(promocode, index)" name="cpnRadio">
                                <span class="coupn_checkmark" id="spnRdoEMTNCF"></span>
                                <span *ngIf="promocode.selected">
                                    <a href="javascript:void(0);" (click)="removeSelectedPromo()" style="color: red; font-size: 11px;">Remove</a>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="all_oters p-0 cancel_policy_book" *ngIf="hotel['CancelPenalties']['CancelPenalty']">
                <div class="para_sentnce cusromGrey">
                    <h3><i class="fal fa-info-circle"></i> Cancellation Policy:</h3>
                    <ul class="list-unstyled m-0" *ngIf="!hotel.CancelPenalties.NonRefundable; else nonRefundable">
                        <ng-container
                            *ngIf="(hotel.CancelPenalties.CancelPenalty | typeof) == 'object'; else otherPanalty">
                            <li class="listcancel" *ngFor="let policy of hotel.CancelPenalties.CancelPenalty">
                                Cancellation made
                                <strong>{{policy.HoursBefore}}</strong> hours before checkin
                                <strong>{{policy.Penalty.Currency}} {{policy.Penalty.Value}}</strong> will be charged as
                                cancellation penalty.
                            </li>
                        </ng-container>
                        <ng-template #otherPanalty>
                            <li class="listcancel">
                                You may cancel your booking for <strong>no charge</strong> on or before
                                <strong>{{hotel.CancelPenalties.CancelPenalty | date: 'dd-MM-yyyy'}} </strong>
                            </li>
                        </ng-template>
                    </ul>
                    <ng-template #nonRefundable>
                        <ul class="list-unstyled m-0">
                            <li class="listcancel">
                                Non Refundable
                            </li>
                        </ul>
                    </ng-template>
                    <div class="para_sentnce">
                        <strong>Remarks:</strong>
                        <p [innerHTML]="hotel.Remarks"></p>
                    </div>
                    <div class="para_sentnce"><strong>Additional charges may apply</strong> </div>
                </div>
            </div> -->
        </div>
    </div>
</div>
</div>
<ngx-loading [show]="loading"
    [config]="{primaryColour: primaryColour, secondaryColour: secondaryColour, tertiaryColour: primaryColour, backdropBorderRadius: '3px',fullScreenBackdrop:true}"
    [template]="loadingTemplate"></ngx-loading>